/** A long-lived port to the extension, as `chrome.runtime.connect` returns it to a page. */
export interface ChromePort {
  onMessage: { addListener(listener: (message: unknown) => void): void };
  onDisconnect: { addListener(listener: () => void): void };
}

/**
 * `chrome.runtime` as a page sees it. Chrome only defines it when an installed
 * extension lists the page's origin in `externally_connectable`.
 */
export interface ChromeRuntime {
  sendMessage?(
    extensionId: string,
    message: unknown,
    callback: (response: unknown) => void,
  ): void;
  connect?(extensionId: string): ChromePort;
  lastError?: { message?: string };
}

export function getChromeRuntime(): ChromeRuntime | undefined {
  const global = globalThis as Record<string, unknown>;
  const chrome = global.chrome as { runtime?: ChromeRuntime } | undefined;
  return chrome?.runtime;
}
